import { get } from "./base";

export async function getCourseLearningRecord(courseId) {
    let params = { "courseId": courseId };
    let respObj = await get("/bus/score/user-assess-info", params);
    return respObj;
}

//获取线下课程学习情况
export async function getUserOfflineSign(params) {
    let respObj = await get("/bus/score/user-signin-info",params);
    return respObj;
}